// extracted by mini-css-extract-plugin
export var scoreComparisonContainer = "ScoreComparison-module--score-comparison-container--z3CDy";
export var agentScore = "ScoreComparison-module--agent-score--OWH0g";